import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import globalContext from '../../../../config/context';

//material-ui core
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import TextField from '@material-ui/core/TextField/TextField';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';

//material-ui Icons

//import others

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 400,
  },
  div: {
    marginBottom: 20,
  },
  button: {
    position: 'absolute',
  },
  input: {
    // display: 'none',
    marginLeft: 24,
    width: 400,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const DialogPersil = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();
  const {
    kecamatan,
    setKecamatan,
    kecamatanOptions,
    handleKecamatan,
    itemKecamatan,
    kelurahan,
    setKelurahan,
    kelurahanOptions,
    handleKelurahan,
    itemKelurahan,
    shpPersil,
    shpPersilHandler,
    shxPersil,
    shxPersilHandler,
    dbfPersil,
    dbfPersilHandler,
    progressPersil,
    onUploadPersil,
  } = props;

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    // setActiveStep(0);
    onUploadPersil();
  };

  useEffect(() => {
    if (pencarian.kecamatan) {
      setKecamatan(pencarian.kecamatan);
    }
    if (pencarian.kelurahan) {
      setKelurahan(pencarian.kelurahan);
    }
  }, [pencarian.kecamatan, setKecamatan, pencarian.kelurahan, setKelurahan]);

  const stepKelurahan = () => {
    return (
      <div>
        <Autocomplete
          id="combo-box-kecamatan"
          className={classes.comboBox}
          options={itemKecamatan}
          getOptionLabel={(option) => (option ? option.kd_kecamatan + ' - ' + option.nm_kecamatan : '')}
          value={kecamatanOptions}
          onChange={handleKecamatan}
          renderInput={(params) => <TextField {...params} label="Kecamatan" variant="outlined" />}
        />

        <Autocomplete
          id="combo-box-kelurahan"
          className={classes.comboBox}
          disabled={kecamatan === '' ? true : false}
          options={itemKelurahan}
          getOptionLabel={(option) => (option ? option.kd_kelurahan + ' - ' + option.nm_kelurahan : '')}
          value={kelurahanOptions}
          onChange={handleKelurahan}
          renderInput={(params) => <TextField {...params} label="Kelurahan" variant="outlined" />}
        />
      </div>
    );
  };

  const stepUpload = () => {
    return (
      <div>
        <div className={classes.div} disabled={kelurahan === '' ? true : false}>
          <label htmlFor="contained-button-shp" className={classes.button}>
            <Button variant="contained" color="primary" component="span">
              Upload SHP
            </Button>
          </label>
          <input
            required
            // accept="*"
            className={classes.input}
            id="contained-button-shp"
            name="shp"
            onChange={shpPersilHandler}
            type="file"
          />
        </div>

        <div className={classes.div} disabled={kelurahan === '' ? true : false}>
          <label htmlFor="contained-button-shx" className={classes.button}>
            <Button variant="contained" color="primary" component="span">
              Upload SHX
            </Button>
          </label>
          <input
            required
            // accept="*"
            className={classes.input}
            id="contained-button-shx"
            name="shx"
            onChange={shxPersilHandler}
            type="file"
          />
        </div>

        <div className={classes.div} disabled={kelurahan === '' ? true : false}>
          <label htmlFor="contained-button-dbf" className={classes.button}>
            <Button variant="contained" color="primary" component="span">
              Upload DBF
            </Button>
          </label>
          <input
            required
            // accept="*"
            className={classes.input}
            id="contained-button-dbf"
            name="dbf"
            onChange={dbfPersilHandler}
            type="file"
          />
        </div>
      </div>
    );
  };

  function getSteps() {
    return ['Kelurahan', 'Upload'];
  }

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return stepKelurahan();
      case 1:
        return stepUpload();
      default:
        return 'Unknown stepIndex';
    }
  }

  //loading persen------------------------------------------------------------------------------------------------------
  CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
  };

  function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="static" {...props} />
        <Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <div style={{paddingBottom: 10}}>All steps completed</div>
            <div style={{display: 'flex'}}>
              <Button variant="contained" color="primary" onClick={handleReset} style={{marginRight: 15}}>
                Upload
              </Button>
              <CircularProgressWithLabel value={progressPersil} />
            </div>
          </div>
        ) : (
          <div>
            <div>{getStepContent(activeStep)}</div>
            <div>
              <Button disabled={activeStep === 0} onClick={handleBack} className={classes.backButton}>
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                disabled={
                  (kecamatan === '' || kelurahan === '') && activeStep === 0
                    ? true
                    : (shpPersil === null || shxPersil === null || dbfPersil === null) && activeStep === 1
                }>
                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DialogPersil;
